import { useEffect, useRef, useState } from 'react';

const WHATSAPP_URL = 'https://wa.me/5516981106759?text=Ol%C3%A1%2C%20preciso%20de%20ajuda%20jur%C3%ADdica';

const services = [
  {
    icon: 'ri-mail-line',
    title: 'Recuperação de Contas',
    description: 'Atuamos na recuperação de contas em redes sociais, e-mails e plataformas digitais invadidas por terceiros de forma ilícita.',
  },
  {
    icon: 'ri-refund-2-line',
    title: 'Restituição de Valores',
    description: 'Ação judicial e extrajudicial para recuperar valores perdidos em golpes bancários, Pix indevido e transferências fraudulentas.',
  },
  {
    icon: 'ri-file-shield-2-line',
    title: 'Ações Contra Fraudes',
    description: 'Representação legal em casos de fraudes financeiras, estelionato digital e crimes contra o sistema financeiro nacional.',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: 'Consultoria Jurídica Digital',
    description: 'Orientação jurídica especializada em segurança digital, proteção de dados e prevenção de crimes cibernéticos.',
  },
];

export default function Services() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) { setVisible(true); obs.disconnect(); } }, { threshold: 0.1 });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);

  return (
    <section
      id="servicos"
      className="py-28"
      ref={ref}
      style={{ background: 'linear-gradient(180deg,#0B2F5B 0%, #123E73 100%)' }}
    >
      <div className="max-w-7xl mx-auto px-6">
        <div
          className="text-center mb-16"
          style={{
            opacity: visible ? 1 : 0,
            transform: visible ? 'translateY(0)' : 'translateY(30px)',
            transition: 'all 0.6s cubic-bezier(0.4,0,0.2,1)',
          }}
        >
          <span className="text-xs font-bold tracking-widest uppercase mb-3 inline-block" style={{ color: '#C9A24A' }}>
            O que fazemos
          </span>
          <h2 className="font-serif text-4xl lg:text-5xl font-bold text-white mb-4">
            Nossos <span style={{ color: '#C9A24A' }}>Serviços</span>
          </h2>
          <p className="text-white/70 text-lg max-w-2xl mx-auto">
            Soluções jurídicas completas para vítimas de golpes bancários e crimes digitais.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service, i) => (
            <article
              key={i}
              className="group rounded-2xl p-8 flex flex-col cursor-pointer transition-all duration-300"
              style={{
                background: '#FFFFFF',
                opacity: visible ? 1 : 0,
                transform: visible ? 'translateY(0)' : 'translateY(40px)',
                transition: `all 0.6s cubic-bezier(0.4,0,0.2,1) ${0.1 * i}s`,
              }}
              onMouseEnter={(e) => { (e.currentTarget as HTMLElement).style.transform = 'translateY(-6px)'; (e.currentTarget as HTMLElement).style.boxShadow = '0 24px 48px rgba(11,47,91,0.18)'; }}
              onMouseLeave={(e) => { (e.currentTarget as HTMLElement).style.transform = 'translateY(0)'; (e.currentTarget as HTMLElement).style.boxShadow = 'none'; }}
            >
              <div
                className="w-16 h-16 flex items-center justify-center rounded-full mb-6 shrink-0"
                style={{ background: 'linear-gradient(135deg,#C9A24A,#E1C67A)' }}
              >
                <i className={`${service.icon} text-2xl`} style={{ color: '#0B2F5B' }} />
              </div>
              <h3 className="font-bold text-lg mb-3 font-sans" style={{ color: '#0B2F5B' }}>
                {service.title}
              </h3>
              <p className="text-sm leading-relaxed flex-1" style={{ color: '#1A1A1A', opacity: 0.68 }}>
                {service.description}
              </p>
              <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-6 inline-flex items-center gap-1.5 text-sm font-semibold transition-all duration-200 cursor-pointer group-hover:gap-3"
                style={{ color: '#C9A24A' }}
              >
                Consultar agora <i className="ri-arrow-right-line" />
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
